/**
 * Форматированить число как валюту с 2-ными знаками
 * @param {number} amount - Сумма для форматирования
 * @param locales - Локаль для форматирования
 * @returns {number} Форматированная строка валюты
 */
const formatCurrency = (amount, locales = 'ru-RU') => parseFloat(
  new Intl.NumberFormat(locales, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: false,
  }).format(amount).replace(',', '.')
);

export default {
  formatCurrency,
};
